// Module
var code = `<header class="header"> <component-logo></component-logo> <div class="right-side" id="auth-side"> <component-search></component-search> <component-user-item></component-user-item> <component-logout-button></component-logout-button> </div> </header> `;
// Exports
export default code;